export const getDateTime = (date) => {
  if (!date) {
    return new Date()
  }
  const updatedDate = new Date(date)
  return updatedDate
}